import axios from 'axios';
import { selectorWithDefaultValue } from 'src/utils/recoil/withDefaultValue';

export const dealcloudFieldsSelector = selectorWithDefaultValue({
  defaultValue: [],
  key: 'CORE-EXPLORE/DEALCLOUDV2/MODAL-FIELDS',
  get: async () => {
    const response = await axios.get(`/api/v1/dealcloud/fields`);
    return response.data;
  },
});
